import React from "react";
import { Navigate } from "react-router-dom";
import { useAbility } from "../Contexts/AbilityContext";
import { useSelector } from "react-redux";
import { Button } from "@fluentui/react-components";
import "./CSS/ProtectedRoute.css";

/**
 * ProtectedRoute Component
 * Vérifie si l'utilisateur a les permissions nécessaires pour accéder à une route
 * 
 * @param {string} module - Le nom du module (ex: "Queue", "Flow", "Agent", etc.)
 * @param {React.ReactNode} children - Le composant à rendre si l'accès est autorisé
 * @param {string} redirectTo - La route vers laquelle rediriger si l'accès est refusé (par défaut: "/")
 */
const ProtectedRoute = ({ module, children, redirectTo = "/" }) => {
  const ability = useAbility();
  const SCOPES_NAMES = useSelector((state) => state.reducer.SCOPES_NAMES);

  // Vérifie si l'utilisateur a au moins une permission (read/create/update/delete) sur main dans au moins un scope
  const hasAnyPermissionOnMain = () => {
    if (!ability || !SCOPES_NAMES || !module) {
      return false;
    }

    const actions = ["read", "create", "update", "delete"];
    return SCOPES_NAMES.some(scope => 
      actions.some(action => ability.can(action, `${module}.main@${scope}`))
    );
  };

  const hasPermission = hasAnyPermissionOnMain();

  if (!hasPermission) {
    return (
      <div className="access-denied-container">
        <div className="access-denied-content">
          <h1 className="access-denied-title">Accès Refusé</h1>
          <p className="access-denied-message">
            Vous n'avez pas les permissions nécessaires pour accéder à cette page.
          </p>
          <p className="access-denied-submessage">
            Veuillez contacter votre administrateur si vous pensez que c'est une erreur.
          </p>
          <Button 
            appearance="primary"
            onClick={() => window.location.href = redirectTo}
          >
            Retour à l'accueil
          </Button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
